export default "__VITE_ASSET__Yp1cFlDR__"